import React from 'react';

import styles from '../../pagination.module.scss';

export default function PaginationLabel(props: {
  offset: number;
  limit: number;
  total: number;
  activePage: number;
  unit: React.ReactNode;
  paginationLabelResolver?: (reviewCount: string, totalCount: number) => React.ReactNode;
  reviewCountSymbol?: string;
}) {
  const {
    offset,
    limit,
    total,
    activePage,
    unit,
    paginationLabelResolver,
    reviewCountSymbol = ' - ',
  } = props;
  const newOffset = offset + 1;
  const newLimit = Math.min(limit * activePage, total);

  return (
    <div className={styles.paginationLabel} data-testid="paginationLabel-wrapper">
      {paginationLabelResolver ? (
        paginationLabelResolver(`${newOffset}${reviewCountSymbol}${newLimit}`, total)
      ) : (
        <>
          {`${newOffset} - ${newLimit} / ${total}`}&nbsp;
          {unit}
        </>
      )}
    </div>
  );
}
